import React, { useState } from 'react';
import { Box, Tabs, Tab } from '@mui/material';
import PaymentSettingsTable from './PaymentSettingsTable';
import DepositMethodsTable from './DepositMethodsTable';
import WithdrawMethodsTable from './WithdrawMethodsTable';
import WithdrawWallet from './WithdrawWallet';
import styles from './Payments.module.scss';

interface PaymentsTabProps {
  siteId: string | number;
}

const PaymentsTab: React.FC<PaymentsTabProps> = ({ siteId }) => {
  const [subTabValue, setSubTabValue] = useState(0);

  const handleSubTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setSubTabValue(newValue);
  };

  return (
    <Box className={styles.container}>
      <Tabs
        value={subTabValue}
        onChange={handleSubTabChange}
        variant="scrollable"
        scrollButtons="auto"
        className={styles.subTabs}
      >
        <Tab label="Deposit Methods" disableRipple />
        <Tab label="Withdraw Methods" disableRipple />
        <Tab label="Withdraw Wallet" disableRipple />
        <Tab label="Settings" disableRipple />
      </Tabs>

      {subTabValue === 0 && <DepositMethodsTable siteId={siteId} />}

      {subTabValue === 1 && <WithdrawMethodsTable siteId={siteId} />}

      {subTabValue === 2 && <WithdrawWallet siteId={siteId} />}

      {subTabValue === 3 && <PaymentSettingsTable siteId={siteId} />}
    </Box>
  );
};

export default PaymentsTab;
